import { IAccountDetails, IOtpResponse } from "../models/IAccountDetails";
import {
  IAccountPayload,
  IBranch,
  IFileUpload,
  IFileUploadResponse,
  IOtpPayloadValidate,
  IUpgrade,
  IUpgradeResponse,
  IUserIdentity,
  IValidateAccBvnNin,
  IValidateAccResponse,
  IValidationResponse,
} from "../models/IAccount";
import { getApi, postApi } from "./api";
import { serviceUrls } from "./serviceUrls";
import { Ireftype } from "../Components/AddReffAcurrent";

export const services = {
  ValidationAccountNumberWithOTP: async (
    payload: IAccountPayload
  ): Promise<IValidateAccResponse> =>
    postApi<IValidateAccResponse, IAccountPayload>(
      serviceUrls.ValidationAccountNumberWithOTP,
      payload
    )
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  ValidationAccountNumber: async (
    payload: IAccountPayload
  ): Promise<IAccountDetails[]> =>
    postApi<IAccountDetails, IAccountPayload>(
      serviceUrls.validationAccountNumber,
      payload
    )
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  validateOTP: async (payload: IOtpPayloadValidate): Promise<IOtpResponse> =>
    postApi<IOtpResponse, IOtpPayloadValidate>(serviceUrls.validateOtp, payload)
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  CurrentReferee: async (payload: Ireftype): Promise<IOtpResponse> =>
    postApi<IOtpResponse, Ireftype>(serviceUrls.CurrentReferee, payload)
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  DomiciliaryReferee: async (payload: Ireftype): Promise<IOtpResponse> =>
    postApi<IOtpResponse, Ireftype>(serviceUrls.DomiciliaryReferee, payload)
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  uploadFile: async (payload: IFileUpload): Promise<IFileUploadResponse> =>
    postApi<IFileUploadResponse, IFileUpload>(serviceUrls.UploadFile, payload)
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  UpgradeSwiftToTier2: async (payload: IUpgrade): Promise<IUpgradeResponse> =>
    postApi<object[], IUpgrade>(serviceUrls.UpgradeSwiftToTier2, payload)
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  ValidateIdentity: async (
    payload: IUserIdentity
  ): Promise<IValidationResponse> =>
    postApi<IValidationResponse, IUserIdentity>(
      serviceUrls.ValidateIdentity,
      payload
    )
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  ValidateAccBvnNin : async (
    payload: IValidateAccBvnNin
  ): Promise<IValidationResponse> =>
    postApi<IValidationResponse, IValidateAccBvnNin>(
      serviceUrls.validateAcctWithBvnNin,
      payload
    )
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
  GetBranches: async (): Promise<IBranch[]> =>
    getApi<IBranch[]>(serviceUrls.BranchCodeList)
      .then((res) => res.data)
      .catch((err) => {
        return err?.response;
      }),
};
